import _regeneratorRuntime from "E:/workspace/hw/moment-vue-h5-new/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "E:/workspace/hw/moment-vue-h5-new/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { liveDetail, getEmojiList as _getEmojiList, wechatLogin, liveZan, liveTotalZan, qqLogin, comment, commentEmoji, getUserInfoByToken, commentList, clientCommentList, wechatShare, addVisit as _addVisit, liveNewList } from '@/api/live';
import wx from 'weixin-js-sdk';
import { parseTime, getUrlParam, getUrlParamByName } from "@/utils/index";
import { hideTitleBar, openShare as _openShare, setStatusBarStyle } from "@/utils/utils";
import BaseInfo from './components/BaseInfo.vue';
import CommentWrap from './components/CommentWrap.vue';
import { getCookie, setCookie } from '@/utils/cookie';
import VueDPlayer from 'vue-dplayer';
import 'vue-dplayer/dist/vue-dplayer.css';
window.Hls = require('hls.js');
import LikeHeart from "./like";
export default {
  name: "live",
  components: {
    BaseInfo: BaseInfo,
    CommentWrap: CommentWrap,
    'd-player': VueDPlayer
  },
  data: function data() {
    return {
      client: false,
      topContentData: [],
      x5VideoShow: false,
      dpOptions: {
        live: false,
        video: {
          type: 'auto',
          url: ''
        },
        autoplay: false
      },
      page: 1,
      order: 1,
      showPlayVideo: true,
      imagesShow: false,
      imagesPosition: 0,
      imagesList: [],
      active: 'desc',
      isClien: false,
      isAndroid: false,
      isWechat: navigator.userAgent.indexOf('MicroMessenger') > -1,
      isQQ: navigator.userAgent.indexOf('QQ\/') != -1,
      passportToken: '',
      userInfo: {},
      unioncid: 20,
      // 公众号ID
      commentText: '',
      popEmojiShow: false,
      popShow: false,
      contentData: [],
      contentLoading: false,
      contentUpLoading: false,
      contentFinished: false,
      commentLoading: false,
      commentFinished: false,
      commentLastId: 0,
      showComment: true,
      commentList: [],
      liveId: '',
      liveInfo: {},
      liveNewInfoId: '',
      playerOptions: {
        lang: 'zh-cn',
        live: false,
        loop: false,
        video: {
          type: 'auto',
          url: '',
          //value.videoUrl,
          pic: '' //value.videoImg
        },
        autoplay: false,
        preload: 'none'
      },
      emojiShow: false,
      emojiList: [],
      shareImgUrl: 'https://j.rednet.cn/images/shareLogo/moment.png',
      heartwidth: 180,
      //初始宽度
      heartHeight: 260,
      //初始高度
      heartList: [],
      //初始数组
      heartCount: 0,
      //累加计数初始值
      ostype: '',
      animate: true,
      showElement: true // 控制元素的显示状态
    };
  },
  computed: {},
  filters: {
    dateTransfer: function dateTransfer(str) {
      //获得当前运行环境时间
      var d = new Date(),
        currentDate = new Date(str),
        tmpHours = currentDate.getHours();
      //算得时区
      var time_zone = -d.getTimezoneOffset() / 60;
      //少于0的是西区 西区应该用时区绝对值加京八区 重新设置时间（西区时间比东区时间早 所以加时区间隔）
      if (time_zone < 0) {
        time_zone = Math.abs(time_zone) + 8;
        currentDate.setHours(tmpHours + time_zone);
      } else {
        //大于0的是东区  东区时间直接跟京八区相减
        time_zone -= 8;
        currentDate.setHours(tmpHours - time_zone);
      }
      var oDate = new Date(currentDate);
      var oMonth = oDate.getMonth() + 1;
      var oDay = oDate.getDate();
      var oHour = oDate.getHours();
      var oMin = oDate.getMinutes();
      if (oMonth < 10) oMonth = '0' + oMonth;
      if (oDay < 10) oDay = '0' + oDay;
      if (oHour < 10) oHour = '0' + oHour;
      if (oMin < 10) oMin = '0' + oMin;
      return oMonth + '-' + oDay + ' ' + oHour + ':' + oMin;
    }
  },
  watch: {
    'imagesShow': function imagesShow(params) {
      this.$nextTick(function () {
        document.getElementById('img-preview').addEventListener('touchmove', function (event) {
          event.preventDefault();
        });
      });
    },
    active: function active(newVal, oldVal) {
      if (newVal == 'comment') {
        this.commentScrollToBottom();
      }
    }
  },
  mounted: function mounted() {
    var winHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    // var body = document.querySelector('body')
    // window.onresize = function() {
    //   var inputDom = document.querySelector('.emoji-wrap')
    //   var inputDomHeight = inputDom.clientHeight
    //   if (winHeight - inputDomHeight > 50) {
    //     body.style.height = winHeight + 'px'
    //   } else {
    //     body.style.height =  '100%'
    //   }
    // }
    // var self = this

    this.createCanvas();
    this.$el.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy: function beforeDestroy() {
    // 移除事件监听
    this.$el.removeEventListener('scroll', this.handleScroll);
  },
  created: function created() {
    this.liveId = getUrlParam("liveid");
    this.unioncid = process.env.NODE_ENV === "staging" ? 20 : 23;
    var u = navigator.userAgent;
    this.isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端
    this.ostype = getUrlParam('ostype');
    this.passportToken = getUrlParam('token');
    // console.log('getUrlParamByName',getUrlParamByName('userid'))
    if (!getUrlParamByName('userid')) {
      this.client = false;
    } else {
      this.clientDeal(); //客户端相应处理
      hideTitleBar(this.ostype);
    }
    this.getUserInfo();
    this.getLiveDetail();
    this.getEmojiList();
    this.commentOnLoad('new');
    this.addVisit();
    // var self = this
    // setInterval(function(){
    //   self.commentOnLoad('new')
    // },10000)
  },
  updated: function updated() {
    // 解决IOS 无法自动聚焦问题
    if (this.popEmojiShow) {
      //var popDom = document.querySelector('.emoji-pop')
      if (this.emojiShow) {
        this.$refs.userCommentInput.blur();
      } else {
        this.$refs.userCommentInput.focus();
        this.fastLogin();
      }
    }
  },
  methods: {
    // 排序
    handleOrder: function handleOrder() {
      var _this2 = this;
      this.order = this.order == 1 ? 0 : 1;
      liveDetail(this.liveId, 'queryOnlineLiveInfoPage', 1, this.order).then(function (resp) {
        if (resp.code == 0) {
          _this2.dealContentData(resp.data, false, true, true);
          _this2.showPlayVideo = false;
          _this2.$nextTick(function () {
            _this2.showPlayVideo = true;
            _this2.$forceUpdate();
          });
        }
      });
    },
    // h5播放器
    showH5Video: function showH5Video(videoUrl, videoImg) {
      var _this3 = this;
      this.x5VideoShow = true;
      this.$nextTick(function () {
        _this3.$refs.contentPlayer.dp.video.setAttribute('x5-playsinline', true);
        _this3.$refs.contentPlayer.dp.switchVideo({
          url: videoUrl,
          pic: videoImg
        });
        _this3.$refs.contentPlayer.dp.play();
      });
    },
    x5VideoCloseHandle: function x5VideoCloseHandle() {
      this.x5VideoShow = false;
      var that = this;
      setTimeout(function () {
        if (that.$refs.livePlayer.length) {
          that.$refs.livePlayer.forEach(function (item) {
            item.dp.video.setAttribute('x5-playsinline', 'true');
          });
        }
      }, 1000);
    },
    // 点赞
    addFav: function addFav(infoId, num, index) {
      var _this4 = this;
      var top = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      liveZan(this.liveId, infoId).then(function (resp) {
        if (resp.code == 0) {
          // 缓存点过爱心的
          var zan = localStorage.getItem('zanArr') ? JSON.parse(localStorage.getItem('zanArr')) : [];
          zan.indexOf(infoId) == -1 ? zan.push(infoId) : '';
          localStorage.setItem('zanArr', JSON.stringify(zan));
          if (top) {
            _this4.topContentData[index].zanStatus = 2;
            _this4.topContentData[index].starNum = num + 1;
          } else {
            _this4.contentData[index].zanStatus = 2;
            _this4.contentData[index].starNum = num + 1;
          }
        }
      });
    },
    addTotalFav: function addTotalFav() {
      var _this5 = this;
      liveTotalZan(this.liveId).then(function (resp) {
        if (resp.code == 0) {
          _this5.liveInfo.starNum = resp.data;
          // // 缓存点过爱心的
          // var zan = localStorage.getItem('zanArr')
          //   ? JSON.parse(localStorage.getItem('zanArr'))
          //   : []
          // zan.indexOf(infoId) == -1 ? zan.push(infoId) : ''
          // localStorage.setItem('zanArr', JSON.stringify(zan))
        }
      });
    },
    // 点击图片显示
    imgShow: function imgShow(item, index, type) {
      this.imagesShow = true;
      this.imagesList = [];
      // item.onlineLivePictureList.forEach(item => {
      //   this.imagesList.push(item.imgUrl)
      // })
      this.imagesList = item.images;
      if (type === 'rich') {
        this.imagesPosition = item.images.indexOf(index);
      } else {
        this.imagesPosition = index;
      }
    },
    // 处理内容数据
    dealContentData: function dealContentData(data) {
      var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var order = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var top = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      if (data.topLiveInfo && data.topLiveInfo.length) {
        this.topContentData = top ? data.topLiveInfo : this.topContentData.concat(data.topLiveInfo);
        this.dealImg(this.topContentData);
      }
      this.contentData = order ? data.liveInfoList : this.contentData.concat(data.liveInfoList);
      this.dealImg(this.contentData);
      // 获取最新id
      // console.log('this.page --------',this.page ,this.order,this.contentData[0])
      if (this.page == 1 && this.order && this.contentData[0]) {
        this.liveNewInfoId = this.contentData[0].liveInfoId;
      }
      // 加载状态结束
      if (status) {
        this.contentUpLoading = false;
      } else {
        this.contentLoading = false;
      }
      if (data.liveInfoList.length < 10) {
        this.contentFinished = true;
        if (!this.order) {
          if (this.contentData.length) {
            this.liveNewInfoId = this.contentData[this.contentData.length - 1].liveInfoId;
          }
        }
      }
      if (this.contentData.length > 0) {
        this.active = 'pic';
      }
      if (this.contentData.length === 0 && this.liveInfo.commentControl) {
        // 图文直播为空且开了评论，则tab高亮：互动聊天
        this.active = 'comment';
      }
    },
    // 处理内容高度宽度问题
    dealImg: function dealImg(data) {
      var _this6 = this;
      var zan = localStorage.getItem('zanArr') ? JSON.parse(localStorage.getItem('zanArr')) : [];
      data.forEach(function (value, index) {
        value.playerOptions = {
          lang: 'zh-cn',
          live: false,
          loop: false,
          video: {
            type: 'auto',
            url: value.videoUrl,
            pic: value.videoImg
          },
          autoplay: false,
          preload: 'none'
        };
        value.zanStatus = zan.indexOf(value.liveInfoId) == -1 ? 1 : 0;
        value.images = [];
        if (value.liveInfoType == 2 && value.onlineLivePictureList.length) {
          value.show = false;
          // 图片点击展示
          value.onlineLivePictureList.forEach(function (i) {
            value.images.push(i.imgUrl);
          });
          value.images.push();
          var imgWidth = '100%';
          var imgHeight = '100%';
          if (value.onlineLivePictureList.length == 2) {
            imgWidth = '47%';
            imgHeight = '2.36rem';
          } else if (value.onlineLivePictureList.length >= 3) {
            imgWidth = '31%';
            imgHeight = '1.55rem';
          }
          value.imgWidth = imgWidth;
          value.imgHeight = imgHeight;
        }
        var contentImages = _this6.getContentImg(value.contentTxt);
        if (contentImages && contentImages.length > 0) {
          value.images = value.images.concat(contentImages);
        }
        // console.log('contentImages', contentImages, this.contentData)
      });
    },
    getContentImg: function getContentImg(content) {
      var imgReg = /<img.*?(?:>|\/>)/gi;
      var srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
      var arr = content.match(imgReg); //筛选所有的img
      var srcArr = [];
      if (!arr) {
        return;
      }
      for (var i = 0; i < arr.length; i++) {
        var src = arr[i].match(srcReg);
        srcArr.push(src[1]);
      }
      return srcArr;
    },
    contentOnLoad: function contentOnLoad() {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this7.page = _this7.page + 1;
              _context.next = 3;
              return liveDetail(_this7.liveId, 'queryOnlineLiveInfoPage', _this7.page, _this7.order);
            case 3:
              data = _context.sent;
              if (data.code == 0) {
                _this7.dealContentData(data.data);
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    clientDeal: function clientDeal() {
      var ostype = getUrlParam('ostype');
      if (ostype) {
        this.client = true;
        var fileref = document.createElement('script');
        fileref.setAttribute('type', 'text/javascript');
        fileref.setAttribute('src', 'https://j.rednet.cn/js/webview.js');
        document.getElementsByTagName('head')[0].appendChild(fileref);
        setStatusBarStyle({
          type: 1
        }, this.ostype); // 系统状态栏样式；
        if (ostype == 'ios') {
          this.client = true;
          if (typeof fileref != 'undefined') {
            fileref.onload = function () {
              setTimeout(function () {
                clientJsBridge('initNews', {
                  id: getUrlParam('liveid'),
                  type: 'live'
                });
              }, 500);
            };
          }
        }
      }
    },
    addVisit: function addVisit() {
      // 增加访问量
      var data = {
        'siteId': 6,
        'relevanceId': this.liveId,
        'modelType': 'LIVE',
        'viewType': 'SHARE'
      };
      _addVisit(data, getUrlParamByName('userid'));
    },
    fastLogin: function fastLogin() {
      var _this8 = this;
      if ((this.isWechat || this.isQQ) && this.userInfo.openid || this.userInfo.passportId || this.client) {
        return true;
      } else if (this.isWechat && !this.userInfo.openId) {
        // 微信快捷授权登录

        wechatLogin(this.unioncid).then(function (resp) {
          if (resp.status == 2) {
            setCookie('tcode', resp.data.tcode, 7000);
            window.location.href = resp.data.url;
          } else if (resp.status == 1) {
            _this8.userInfo = {
              openid: resp.data.openid,
              nickName: resp.data.nickname
            };
            setCookie('wechatToken', JSON.stringify(_this8.userInfo), 7000);
            _this8.userInfo = JSON.parse(getCookie('wechatToken'));
          }
        });
      } else if (this.isQQ && !this.userInfo.openId) {
        // QQ浏览器登录
        qqLogin().then(function (resp) {
          if (resp.status == 2) {
            setCookie('tcode', resp.data.tcode, 7000);
            window.location.href = resp.data.url;
          } else if (resp.status == 1) {
            _this8.userInfo = {
              openid: resp.data.openid,
              nickName: resp.data.nickname
            };
            setCookie('qqToken', JSON.stringify(_this8.userInfo), 7000);
            _this8.userInfo = JSON.parse(getCookie('qqToken'));
          }
        });
      } else {
        //红网通行证登录
        if (window.location.host.indexOf('rednet.cn') == -1) {
          window.location.href = 'https://passport.onlyred.net/passport/login?client_id=f65739a0a1be44f8820d485404b53b96&redirect_uri=' + encodeURIComponent(window.location.href);
          if (window.location.host.indexOf('wap.qdxw.com.cn') >= 0) {
            window.location.href = 'https://passport.rednet.cn/passport/login?client_id=40bd9fd577ee4dfaa665e4de49f8929e&redirect_uri=' + encodeURIComponent(window.location.href.split('#')[0]);
          }
        } else {
          //.split('#')[0]
          window.location.href = 'https://passport.rednet.cn/passport/login?client_id=40bd9fd577ee4dfaa665e4de49f8929e&redirect_uri=' + encodeURIComponent(window.location.href);
        }
      }
    },
    getEmojiList: function getEmojiList() {
      var _this9 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var resp;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _getEmojiList(6);
            case 2:
              resp = _context2.sent;
              _this9.emojiList = resp.data.onlineLiveEmoteList;
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    initShare: function initShare() {
      // 设置body标题
      var $body = document.querySelector('body');
      document.title = this.liveInfo.liveName;
      var $metakey = document.querySelector('meta[name="keywords"]');
      var $metaDesc = document.querySelector('meta[name="description"]');
      $metakey.setAttribute('content', this.liveInfo.liveName);
      $metaDesc.setAttribute('content', this.liveInfo.liveDesc);
      // 判断是否时刻，如果是时刻且直播设置了分享图得话
      var href = window.location.href;
      if ((href.indexOf('moment') > 0 || href.indexOf('momenttest') > 0) && this.liveInfo.shareExtPic != '') {
        this.shareImgUrl = this.liveInfo.shareExtPic;
      } else {
        //let host = window.location.host
        // 获取域名不同banner和下载链接
        //let a = host.indexOf('://')
        //let b = host.substring(a + 1, host.indexOf('-wap.rednet.cn'))
        // if(host.indexOf('-wap') != -1){
        //   this.shareImgUrl = 'https://j.rednet.cn/images/shareLogo/' + b + '.png'
        // }else{
        //   let hostNames = ['guancha360','tianxinxw','zhuhui','longhuinews','lxxww', 'xtxnews', 'wcxww', 'tongdaonews', 'ydnews', 'spxrmt', 'chenxinews', 'clxww', 'qdxw','lilingnews','xpnews','hnrd']
        //   let unioncids = [58, 102, 101, 91, 108, 63, 61, 161, 121, 84, 141, 174, 129, 72, 142, 82]
        //   let hostName = host.split('.')[1]
        //   this.shareImgUrl = 'https://j.rednet.cn/images/shareLogo/' + hostName + '.png'
        //   this.unioncid = unioncids[hostNames.indexOf(hostName)]
        // }
        if (this.liveInfo.sharePic) {
          this.shareImgUrl = this.liveInfo.sharePic;
        }
      }
      // QQ分享
      window.setShareInfo({
        title: this.liveInfo.liveName,
        summary: this.liveInfo.liveDesc ? this.liveInfo.liveDesc : this.liveInfo.liveName,
        pic: this.shareImgUrl,
        url: window.location.href.split('#')[0],
        WXconfig: null
      });
      if (this.isWechat) {
        this.share();
      }
    },
    // 分享
    share: function share() {
      var that = this;
      wechatShare(this.unioncid).then(function (json) {
        if (typeof wx != 'undefined' && json) {
          wx.config({
            appId: json.appId,
            timestamp: json.timestamp,
            nonceStr: json.nonceStr,
            signature: json.signature,
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'checkJsApi']
          });
          wx.ready(function () {
            var shareData = {
              title: that.liveInfo.liveName,
              desc: that.liveInfo.liveDesc ? that.liveInfo.liveDesc : that.liveInfo.liveName,
              link: window.location.href,
              imgUrl: that.shareImgUrl,
              success: function success() {
                // 设置成功
                console.log('微信分享接口设置成功');
              }
            };
            wx.updateAppMessageShareData(shareData);
            wx.updateTimelineShareData(shareData);
          });
        }
      });
    },
    getUserInfo: function getUserInfo() {
      var _this10 = this;
      if (getCookie('rednetToken')) {
        // 判断是否红网通行证用户
        this.userInfo = JSON.parse(getCookie('rednetToken'));
      } else if (this.passportToken && this.passportToken != '') {
        getUserInfoByToken(this.passportToken).then(function (resp) {
          console.log('resp ======= ', resp);
          if (resp.errcode) {
            _this10.commentSubmit();
          } else {
            _this10.userInfo = {
              passportId: resp.id,
              nickName: resp.nickName
            };
            setCookie('rednetToken', JSON.stringify(_this10.userInfo), 7200);
            _this10.userInfo = JSON.parse(getCookie('rednetToken'));
          }
        });
      }
      if (this.isWechat) {
        // 判断是否有微信缓存
        if (getCookie('wechatToken')) {
          this.userInfo = JSON.parse(getCookie('wechatToken'));
        }
      } else if (this.isQQ) {
        this.client = false;
        if (getCookie('qqToken')) {
          this.userInfo = JSON.parse(getCookie('qqToken'));
        }
      }
    },
    emojiClickHandle: function emojiClickHandle() {
      this.emojiShow = !this.emojiShow;
      if (this.emojiShow) {
        this.popEmojiShow = true;
        this.$refs.userCommentInput.blur();
      } else {
        var input = document.querySelector('.input-div');
        console.log('this.$refs.dom-------', input);
        // this.popEmojiShow = false
        // this.commentFocus()
        this.popEmojiShow = false;
        input.click();
        //this.$refs.userCommentInput.focus()
      }
    },
    inputBlur: function inputBlur(e) {
      this.popEmojiShow = false;
      this.emojiShow = false;
    },
    commentFocus: function commentFocus() {
      this.popEmojiShow = true;
      this.emojiShow = false;
      // var self = this
      // setTimeout(function(){
      //   self.$refs.userCommentInput.focus()
      // },500)
    },
    // 互动聊天 滚动到最新数据
    commentScrollToBottom: function commentScrollToBottom() {
      var _this11 = this;
      this.$nextTick(function () {
        var element = _this11.$refs.commentList;
        if (element) {
          setTimeout(function () {
            _this11.$refs.commentList.scrollTo({
              top: element.scrollHeight,
              behavior: 'smooth'
            });
          }, 500);
        }
      });
    },
    commentSubmit: function commentSubmit() {
      var _this12 = this;
      // 提交评论 微信里是否登陆 网页版是否登陆
      var params = {
        contentId: getUrlParam('liveid'),
        commentText: this.commentText
      };
      var userId = -1;
      if (!this.commentText) {
        this.$toast('请先填写内容');
        return true;
      }
      if ((this.isWechat || this.isQQ) && this.userInfo.openid) {
        params.openId = this.userInfo.openid;
      } else if (this.userInfo.passportId) {
        params.passportId = this.userInfo.passportId;
      } else if (getUrlParamByName('userid')) {
        //&& this.isAndroid
        userId = getUrlParamByName('userid');
      }
      params.nickName = this.userInfo.nickName;
      if (this.client && (userId == '-1' || userId == 'EWYCZpEDqvLvMhdqygXLAA==')) {
        this.$toast('请先客户端登录再评论');
        return true;
      }
      comment(params, userId).then(function (resp) {
        if (resp.code == 0) {
          params.liveId = getUrlParam('liveid');
          _this12.$toast('留言成功，请等待审核');
          _this12.commentText = '';
          _this12.commentScrollToBottom();

          // commentList(params, userId).then(res => {
          //   if (res.code == 0) {
          //     if (res.data.commentsList != undefined) {
          //       this.commentList = res.data.commentsList
          //     }
          //     this.commentText = ''
          //     this.showNewTip = '评论成功，请等待审核'
          //     setTimeout(() => {
          //       this.showNewTip = false
          //     }, 3000)
          //   }
          // })
        }
      });
    },
    openEmoji: function openEmoji(flag, list) {
      this.popEmojiShow = flag;
      this.emojiShow = flag;
      if (list) {
        this.emojiList = list;
      }
    },
    openShare: function openShare() {
      var params = {
        title: this.liveInfo.liveName,
        share_url: window.location.href.split('#')[0] + '#/live?liveid=' + this.liveInfo.id,
        content: this.liveInfo.liveDesc,
        img_url: this.shareImgUrl
      };
      _openShare(params, this.ostype);
    },
    sendEmoji: function sendEmoji(item) {
      var _this13 = this;
      console.log('item-------', item);
      // 提交评论 微信里是否登陆 网页版是否登陆
      var params = {
        contentId: getUrlParam('liveid'),
        commentText: item.id
      };
      var userId = -1;
      if ((this.isWechat || this.isQQ) && this.userInfo.openid) {
        params.openId = this.userInfo.openid;
      } else if (this.userInfo.passportId) {
        params.passportId = this.userInfo.passportId;
      } else if (getUrlParamByName('userid')) {
        //&& this.isAndroid
        userId = getUrlParamByName('userid');
      }
      params.nickName = this.userInfo.nickName;
      if (this.client && (userId == '-1' || userId == 'EWYCZpEDqvLvMhdqygXLAA==')) {
        this.$toast('请先客户端登录再评论');
        return true;
      }
      commentEmoji(params, userId).then(function (resp) {
        if (resp.code == 0) {
          params.liveId = getUrlParam('liveid');
          _this13.commentOnLoad('new');
          _this13.commentScrollToBottom();
        }
      });
      this.emojiShow = false;
      this.popEmojiShow = false;
    },
    openDanmu: function openDanmu(flag) {
      this.showComment = flag;
    },
    // 下拉加载评论数据
    commentOnLoad: function commentOnLoad(type) {
      var _this14 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var data;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return clientCommentList({
                liveId: _this14.liveId,
                operator: type ? type : 'old',
                commentId: _this14.commentLastId
              }, getUrlParamByName('userid'));
            case 2:
              data = _context3.sent;
              _this14.dealCommentData(data.data, type);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    dealCommentData: function dealCommentData(data, type) {
      if (data.commentsList && data.commentsList.length) {
        var list = data.commentsList.reverse();
        this.commentList = this.commentList.concat(list);
        this.commentLastId = list[list.length - 1]['commentId'];

        // if (data.commentsList.length < 10) {
        //   this.commentFinished = true
        // }
        // this.commentLoading = false
      }
    },
    getLiveDetail: function getLiveDetail() {
      var _this15 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var resp, self;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return liveDetail(_this15.liveId, 'getOnlineLiveDetail');
            case 2:
              resp = _context4.sent;
              if (!(resp.code != 0)) {
                _context4.next = 5;
                break;
              }
              return _context4.abrupt("return", false);
            case 5:
              console.log(resp.data);
              _this15.liveInfo = resp.data;
              self = _this15;
              if (resp.onlineLiveShare && resp.onlineLiveShare.weixinOriginal) {
                _this15.unioncid = resp.onlineLiveShare.weixinOriginal;
              }
              // 如果直播结束 正序显示
              if (_this15.liveInfo.status == '3') {
                _this15.order = 0;
              }
              if (_this15.liveInfo.commentControl) {
                setInterval(function () {
                  self.commentOnLoad('new');
                }, 10000);
              }
              // 直播中
              if (_this15.liveInfo.status == 2) {
                _this15.onlivePeople();
              }
              if (_this15.liveInfo.onlineLiveVideoList.length > 0) {
                _this15.playerOptions.video.url = _this15.liveInfo.onlineLiveVideoList[0].videoUrl;
                _this15.playerOptions.video.pic = _this15.liveInfo.onlineLiveVideoList[0].videoImg;
                _this15.playerOptions.live = _this15.liveInfo.status != 2 ? false : true;
              }
              // console.log(' this.playerOptions.video.url-----', this.playerOptions.video.url)
              if (window.location.host.indexOf('onlyred') != -1) {
                _this15.unioncid = 24;
              }
              // 获取直播列表
              liveDetail(_this15.liveId, 'queryOnlineLiveInfoPage', 1, _this15.order).then(function (resp) {
                if (resp.code == 0) {
                  _this15.dealContentData(resp.data);
                }
              });

              // 点赞人数
              if (_this15.liveInfo.starNum) {
                if (_this15.liveInfo.starNum >= 10000) {
                  _this15.liveInfo.starNum = (_this15.liveInfo.starNum / 10000).toFixed(2) + '万';
                }
              } else {
                _this15.liveInfo.starNum = 0;
              }

              // 总浏览人
              if (_this15.liveInfo.onlineNum) {
                if (_this15.liveInfo.onlineNum >= 10000) {
                  _this15.liveInfo.onlineNum = (_this15.liveInfo.onlineNum / 10000).toFixed(2) + '万';
                }
              } else {
                _this15.liveInfo.onlineNum = 0;
              }
              _this15.animate = _this15.liveInfo.liveName.length > 22;
              if (_this15.liveInfo.liveDesc.length > 0) {
                _this15.active = 'desc';
              }
              _this15.initShare();
            case 20:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    // 直播中 控制在线人数
    onlivePeople: function onlivePeople() {
      var _this16 = this;
      setInterval(function () {
        liveDetail(_this16.liveId, 'getOnlineLiveNum').then(function (resp) {
          if (resp.code == 0) {
            // this.liveInfo.onlineNum =  resp.data.onlineNum

            _this16.liveInfo.onlineNum = resp.data.onlineNum >= 10000 ? (resp.data.onlineNum / 10000).toFixed(2) + '万' : resp.data.onlineNum;
          }
        });
      }, 60000);
      var beginToLiveFlag = false,
        endToLiveFlag = false;
      setInterval(function () {
        // 直播详情获取条数
        var that = _this16;
        liveDetail(that.liveId, 'getOnlineLiveDetail').then(function (resp) {
          if (resp.code == 0 && that.liveInfo.infoCount) {
            that.liveInfo.infoCount = resp.data.infoCount;
          }
          if (getUrlParamByName('userid') && resp.data.onlineLiveVideoList && resp.data.onlineLiveVideoList.length && resp.data.onlineLiveVideoList[0]['videoUrl']) {
            if (resp.data.status == '2' && !beginToLiveFlag) {
              clientJsBridge('BeginToLive', {
                beginTime: resp.data.beginDatetime + ''
              });
              beginToLiveFlag = true;
            } else if (resp.data.status == '3' && !endToLiveFlag) {
              clientJsBridge('EndToLive', {});
              endToLiveFlag = true;
            }
          }
        });
        liveNewList(_this16.liveId, 'queryNewOnlineLiveInfoList', _this16.liveNewInfoId, _this16.order).then(function (resp) {
          if (resp.code == 0) {
            _this16.topContentData = resp.data.topLiveInfoList;
            if (_this16.topContentData.length) _this16.dealImg(_this16.topContentData);
            if (resp.data.liveInfoList.length) {
              _this16.$toast('更新了' + resp.data.liveInfoList.length + '条新内容哦');
              resp.data.liveInfoList.forEach(function (value) {
                value.playerOptions = {
                  lang: 'zh-cn',
                  live: false,
                  loop: false,
                  video: {
                    type: 'auto',
                    url: value.videoUrl,
                    pic: value.videoImg
                  },
                  autoplay: false,
                  preload: 'none'
                };
                value.zanStatus = 1;
                value.images = [];
                if (value.liveInfoType == 2 && value.onlineLivePictureList.length) {
                  value.show = false;
                  // 图片点击展示
                  value.onlineLivePictureList.forEach(function (i) {
                    value.images.push(i.imgUrl);
                  });
                  value.images.push();
                  var imgWidth = '100%';
                  var imgHeight = '100%';
                  if (value.onlineLivePictureList.length == 2) {
                    imgWidth = '47%';
                    imgHeight = '2.36rem';
                  } else if (value.onlineLivePictureList.length >= 3) {
                    imgWidth = '31%';
                    imgHeight = '1.55rem';
                  }
                  value.imgWidth = imgWidth;
                  value.imgHeight = imgHeight;
                }
              });
              for (var n = resp.data.liveInfoList.length - 1; n >= 0; n--) {
                _this16.contentData.unshift(resp.data.liveInfoList[n]);
              }
              _this16.liveNewInfoId = _this16.contentData[0].liveInfoId;
              _this16.showPlayVideo = false;
              _this16.$nextTick(function () {
                _this16.showPlayVideo = true;
                _this16.$forceUpdate();
              });
            }
          }
        });
      }, 10000);
    },
    play: function play() {
      // if (this.liveInfo.onlineLiveVideoList.length) {
      //   // 如果有视频流，暂停显示红色按钮
      //   this.$refs.livePlayer[this.videoSelectIndex].dp.on('pause', function() {
      //     this.liveStatus = 0
      //     this.liveIconShow = 1
      //     this.isPause = 1
      //   })

      //   this.$refs.livePlayer[this.videoSelectIndex].dp.on('play', function() {
      //     this.showCallback = false
      //     $('.playback').hide()
      //     this.liveStatus = 1
      //     this.liveIconShow = 0
      //     this.isPause = 0
      //   })

      //   this.$refs.livePlayer[this.videoSelectIndex].dp.on('ended', function() {
      //       if (getUrlParamByName('userid')) {
      //         clientJsBridge('EndOfVideo', {})
      //       }
      //   })
      // }
    },
    // 图文直播 置顶
    picToTop: function picToTop() {
      var _this17 = this;
      this.$nextTick(function () {
        var element = _this17.$refs.contentList;
        if (element) {
          setTimeout(function () {
            _this17.$refs.contentList.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }, 500);
        }
      });
    },
    // 滚动事件
    handleScroll: function handleScroll(e) {
      var _this18 = this;
      console.log(e);
      this.showElement = false;
      setTimeout(function () {
        _this18.showElement = true;
      }, 1000);
    },
    // 点赞飘心
    createCanvas: function createCanvas() {
      // 飘心
      var _this = this;
      var ctx = document.getElementById("cvs").getContext("2d");
      ctx.canvas.width = _this.heartwidth, ctx.canvas.height = _this.heartHeight, function loop() {
        ctx.clearRect(0, 0, _this.heartwidth, _this.heartHeight);
        _this.heartList.forEach(function (item) {
          item && item.move(ctx);
        });
        requestAnimationFrame(loop);
      }();
    },
    likeHeart: function likeHeart() {
      this.heartList.push(this.createHeart());
      this.addTotalFav();
    },
    getRandomDis: function getRandomDis() {
      if (Math.random() > 0.5) {
        return -(Math.random() * 43);
      } else {
        return +(Math.random() * 43);
      }
    },
    createHeart: function createHeart() {
      this.heartCount++;
      var positionArray = [{
        x: 100,
        y: 400,
        endX: 100,
        endY: 100
      }];
      var img = new Image();
      // img.src = "../../static/img/" + Math.ceil(Math.random() * 2) + ".png";
      // img.src = `../../assets/images/live/emoji/${Math.ceil(Math.random() * 5)}.png`;
      img.src = require("@/assets/images/live/emoji/".concat(Math.ceil(Math.random() * 5), ".png"));
      var p1 = {
        x: 100 + this.getRandomDis(),
        y: 300 + this.getRandomDis()
      };
      var p2 = {
        x: 100 + this.getRandomDis(),
        y: 200 + this.getRandomDis()
      };
      return new LikeHeart({
        id: this.heartCount,
        x: positionArray[0].x,
        y: positionArray[0].y,
        endX: positionArray[0].endX,
        endY: positionArray[0].endY,
        onFadeOut: this.removeItem,
        noAngel: true,
        //决定是否从小到大
        // noScale: true,//决定是否左右摆动
        width: 28,
        //决定心的大小
        height: 28,
        image: img,
        bezierPoint: {
          p0: {
            x: positionArray[0].x,
            y: positionArray[0].y
          },
          p1: p1,
          p2: p2,
          p3: {
            x: positionArray[0].endX,
            y: positionArray[0].endY
          }
        }
      });
    },
    removeItem: function removeItem(item) {
      var array = [];
      for (var i = 0; i < this.heartList.length; i++) {
        if (this.heartList[i].id !== item.id) {
          array.push(this.heartList[i]);
        }
      }
      this.heartList = array;
    }
  }
};